<template>
  <VDataGridV2
    :loader="dataLoader"
    :context-menu="UnitsService.contextMenu"
    entity-type="unit"
    @row:dblclick="openUnitCard"
  >
    <VDataGridColumnV2
      id="id"
      label="№"
      width="50px"
      content-align="left"
    >
      <template #default="{ row }">
        <VLink
          @click="openUnitCard(row)"
        >
          {{ row.id }}
        </VLink>
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
      id="name"
      label="Название"
      width="200px"
      filterable
      filter-send-name="pattern"
      :filter-props="{
        placeholder: 'Название',
        clearable:   true,
      }"
    >
      <template #default="{ row }">
        {{ row.nameFull }} / {{ row.name }}
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
      id="code"
      label="Код по ОКЕИ"
      width="100px"
      filterable
      :filter-props="{
        placeholder: 'Код по ОКЕИ',
        clearable:   true,
      }"
      content-align="center"
      header-class="nowrap"
    >
      <template #default="{ row }">
        {{ row.code }}
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
      id="qtyMultiplier"
      label="Множитель кол-ва"
      width="100px"
      content-align="right"
      header-class="nowrap"
    >
      <template #default="{ row }">
        {{ row.qtyMultiplier }}
      </template>
    </VDataGridColumnV2>

    <VDataGridActionBarV2>
      <VButton
        theme="primary"
        @click="openUnitCard(null)"
      >
        Добавить единицу измерения
      </VButton>
    </VDataGridActionBarV2>
  </VDataGridV2>
</template>

<script lang="ts">

import Unit           from '@/domains/Units/Unit';
import UnitsService   from '@/domains/Units/UnitsService';
import DataGridLoader from '@/lib/components/VDataGridV2/DataGridLoader';

export default defineComponent({
  name: 'UnitsRegistry',

  data() {
    return {
      UnitsService,
      dataLoader: new DataGridLoader(UnitsService.getListPaginated),

    };
  },

  methods: {
    async openUnitCard(row: Unit | null): Promise<void> {
      if (await UnitsService.showUnitCard(row)) {
        this.dataLoader.refresh();
      }
    },
  },
});
</script>
